export default {
  status: {
    DRAFT: {
      label: "Rascunho",
      color: "warning",
      icon: "mdi-pencil",
    },
    OPEN: {
      label: "Aberta",
      color: "primary",
      icon: "mdi-open-in-new",
    },
    CLOSED: {
      label: "Fechada",
      color: "secondary",
      icon: "mdi-close",
    },
    PAID: {
      label: "Pago",
      color: "success",
      icon: "mdi-check",
    },
    CANCELLED: {
      label: "Cancelada",
      color: "error",
      icon: "mdi-cancel",
    },
  },
  itemKey: {
    onlineTicketRevenue: {
      label: "Receita de ingressos online",
      group: "ticketOnline",
      subGroup: "online",
      type: "currency",
      icon: "mdi-currency-brl",
      allowedTypes: ["PERCENTAGE", "TIERS", "FIXED"],
    },
    onlineTicketQty: {
      label: "Quantidade ingressos online",
      group: "ticketOnline",
      subGroup: "online",
      type: "number",
      icon: "mdi-numeric",
      allowedTypes: ["PER_UNIT", "TIERS", "FIXED"],
    },
    onlineCourtesyTicketQty: {
      label: "Quantidade cortesia online",
      group: "ticketOnline",
      subGroup: "online",
      type: "number",
      icon: "mdi-currency-usd-off",
      allowedTypes: ["PER_UNIT", "TIERS", "FIXED"],
    },
    posTicketRevenue: {
      label: "Receita de ingressos POS",
      group: "ticketPOS",
      subGroup: "pos",
      type: "currency",
      icon: "mdi-currency-brl",
      allowedTypes: ["PERCENTAGE", "TIERS", "FIXED"],
    },
    posTicketQty: {
      label: "Quantidade ingressos POS",
      group: "ticketPOS",
      subGroup: "pos",
      type: "number",
      icon: "mdi-numeric",
      allowedTypes: ["PER_UNIT", "TIERS", "FIXED"],
    },
    posCourtesyTicketQty: {
      label: "Quantidade cortesia POS",
      group: "ticketPOS",
      subGroup: "pos",
      type: "number",
      icon: "mdi-currency-usd-off",
      allowedTypes: ["PER_UNIT", "TIERS", "FIXED"],
    },
    offlineTicketRevenue: {
      label: "Receita de ingressos promoter",
      group: "ticketPromoter",
      subGroup: "promoter",
      type: "currency",
      icon: "mdi-currency-brl",
      allowedTypes: ["PERCENTAGE", "TIERS", "FIXED"],
    },
    offlineTicketQty: {
      label: "Quantidade ingressos promoter",
      group: "ticketPromoter",
      subGroup: "promoter",
      type: "number",
      icon: "mdi-numeric",
      allowedTypes: ["PER_UNIT", "TIERS", "FIXED"],
    },
    offlineCourtesyTicketQty: {
      label: "Quantidade cortesia promoter",
      group: "ticketPromoter",
      subGroup: "promoter",
      type: "number",
      icon: "mdi-currency-usd-off",
      allowedTypes: ["PER_UNIT", "TIERS", "FIXED"],
    },
    barItemRevenue: {
      label: "Receita no bar",
      group: "bar",
      type: "currency",
      icon: "mdi-currency-brl",
      allowedTypes: ["PERCENTAGE", "TIERS", "FIXED"],
    },
    barItemQty: {
      label: "Quantidade fichas no bar",
      group: "bar",
      type: "number",
      icon: "mdi-numeric",
      allowedTypes: ["PER_UNIT", "TIERS", "FIXED"],
    },
    barItemTransactionQty: {
      label: "Quantidade de vendas no bar",
      group: "bar",
      type: "number",
      icon: "mdi-numeric",
      allowedTypes: ["PER_UNIT", "TIERS", "FIXED"],
    },
    barPosQty: {
      label: "Quantidade de PDVs utilizados",
      group: "bar",
      type: "number",
      icon: "mdi-printer-pos-star",
      allowedTypes: ["PER_UNIT", "TIERS", "FIXED"],
    },
    barPosPerPartyQty: {
      label: "Quantidade de PDVs utilizados por evento",
      group: "bar",
      type: "number",
      icon: "mdi-printer-pos",
      allowedTypes: ["PER_UNIT", "TIERS", "FIXED"],
    },
    custom: {
      label: "Outros",
      group: "custom",
      type: "currency",
    },
  },
  itemGroups: {
    ticketOnline: {
      label: "Ingressos Online",
      icon: "mdi-ticket",
    },
    ticketPOS: {
      label: "Ingressos POS",
      icon: "mdi-printer-pos",
    },
    ticketPromoter: {
      label: "Ingressos Promoter",
      icon: "mdi-ticket-account",
    },
    bar: {
      label: "Bar",
      icon: "mdi-food-fork-drink",
    },
    custom: {
      label: "Outros",
      icon: "mdi-cog",
    },
  },
  pricingTypes: {
    PER_UNIT: {
      label: "Por unidade",
      icon: "mdi-counter",
      formatter: (config, itemType) => {
        return formatCurrency(config.value) + " /uso";
      },
    },
    FIXED: {
      label: "Fixo",
      icon: "mdi-fixed",
      formatter: (config, itemType) => {
        return formatCurrency(config.value);
      },
    },
    PERCENTAGE: {
      label: "Percentual",
      icon: "mdi-percentage",
      formatter: (config, itemType) => {
        return formatPercentage(config.value);
      },
    },
  },
};

const formatCurrency = (value) =>
  value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
  });

const formatPercentage = (value) => formatNumber(value) + "%";

const formatNumber = (value) =>
  value.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
  });
